<template>
  <EventBase
    :max-height="null"
    :height="null"
    :min-height="null"
    backgroundColor="#FFFFFF"
  >
    <div class="parent my-10">
      <v-img
        :src="banner"
        max-height="450px"
        max-width="450px"
        width="100vw"
        contain
        alt="Christmas Crew 2026: Kids choir & activities! Sunday mornings starting November 8th. Weekly from 10AM - 12:30PM."
      >
      </v-img>
    </div>
    <div class="message mx-3">
      <div class="inner">
        <p class="display-1 text-align-center">
          🎄✨ Join our Christmas Crew 2026! ✨🎄
        </p>
        <p>
          Get ready for a season full of music, laughter, and holiday cheer! Kids ages 3–15 will gather for choir practices, awesome activities, fun games, meaningful lessons, raffles, and so much more!
        </p>
        <p>
          🌟 <span class="font-weight-bold">Two festive performances you won’t want to miss:</span> 
          December 13th & December 21st
        </p>
        <p>
          Don’t worry—kids don’t need to attend every practice to be part of the show. Everyone’s welcome to jump in and shine!
        </p>
        <p>
          🎁 <span class="font-weight-bold">Register today!</span> Make sure to register your children using the button below and we will get the fun started on November 8th @ 10am
        </p>
        <p>
          <a
            href="https://form.jotform.com/252735020232141"
            target="_blank"
            >Click here to register.</a
          >
        </p>
      </div>
    </div>
  </EventBase>
</template>
<script>
import EventBase from "../EventBase.vue";
import banner from "./christmas-crew-2026.png";
export default {
  name: "ChristmasChoir",
  components: {
    EventBase,
  },
  data: () => ({ banner }),
};
</script>
<style lang="scss" scoped>
.button {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1;
}
.parent {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.message {
  border-style: solid;
  border-width: 4px;
  border-color: #fdd205;
  // border-color: #054f25;
  max-width: 1000px;
  background-color: #fee17c;
  // color: white;
  margin-top: 16px;
  margin-bottom: 24px;
  .inner {
    margin: 16px;
  }
}
</style>
